import { DeviceData } from './HeatingApplianceHistory';

export const downsampleMultiTemp = (data: DeviceData[], targetSize = 1000) => {
  if (data.length <= targetSize) return data;

  const bucketSize = data.length / targetSize;
  const result: DeviceData[] = [];

  for (let i = 0; i < targetSize; i++) {
    const start = Math.floor(i * bucketSize);
    const end = Math.floor((i + 1) * bucketSize);
    const bucket = data.slice(start, end);

    // Initialize sums for this bucket
    const sums = { gasTempC: 0, waterTempC: 0, fanSpeed: 0, burningPower: 0 };

    bucket.forEach((obj) => {
      sums.gasTempC += obj.gasTempC;
      sums.waterTempC += obj.waterTempC;
      sums.fanSpeed += obj.fanSpeed;
      sums.burningPower += obj.burningPower;
    });

    const midIndex = Math.floor((start + end) / 2);
    const count = bucket.length;

    result.push({
      timestamp: data[midIndex].timestamp,
      gasTempC: Math.round(sums.gasTempC / count),
      waterTempC: Math.round(sums.waterTempC / count),
      fanSpeed: Math.round(sums.fanSpeed / count),
      burningPower: Math.round(sums.burningPower / count),
      status: data[midIndex].status,
    });
  }

  return result;
};

export const filterHistory = (data: DeviceData[], startDate: string, endDate: string) => {
  return data.filter((item) => {
    const timestamp = Date.parse(item.timestamp);
    const startTimestamp = Date.parse(startDate);
    const endTimestamp = Date.parse(endDate);
    return timestamp >= startTimestamp && timestamp <= endTimestamp;
  });
};

export const getTodayStart = (): Date => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const getTodayEnd = (): Date => {
  const today = new Date();
  return today;
};
